import { render, staticRenderFns } from "./group_list.vue?vue&type=template&id=568fc820&scoped=true&"
import script from "./group_list.vue?vue&type=script&lang=js&"
export * from "./group_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fc820",
  null
  
)

export default component.exports